    import React from 'react';
    import './Contact.css';

    export default function Contact() {
    return (
        <div className="contact-page">
        <h1>Contact</h1>

        <p className="contact-intro">
            Aplicația FRO este destinată exclusiv cluburilor și structurilor afiliate
            Federației Române de Orientare.
        </p>

        <p className="contact-intro">
            Dacă reprezinți un club și dorești acces la aplicație, te rugăm să ne
            contactezi folosind datele de mai jos.
        </p>

        <p className="contact-note">
            Cererile de acces sunt analizate și aprobate de către Federația Română de Orientare.
        </p>

        <div className="contact-details">
            <div className="contact-row">
            <span className="label">Email</span>
            <a
                href="mailto:info@fro.ro?subject=Cerere acces aplicație FRO"
                className="value"
            >
                info@fro.ro
            </a>
            </div>

            <div className="contact-row">
            <span className="label">Telefon</span>
            <a href="tel:+40 21 317 49 99" className="value">
                +40 21 317 49 99
            </a>
            </div>
        </div>
        </div>
    );
    }
